import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { AccessibleImage } from "../../components/AccessibleImage";
import { ErrorPage } from "./components/ErrorPage";
import error from "./error.svg";

export const PageNotFoundErrorPage: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <ErrorPage
      image={
        <AccessibleImage src={error} alt={t("errorpages.accessDenied.title")} />
      }
      title={t("errorpages.notFound.title")}
      message={t("errorpages.notFound.message")}
    />
  );
};
